import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';

const AchievementSection = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 80px 0;
`;

const TimelineContainer = styled.div`
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  
  &::after {
    content: '';
    position: absolute;
    width: 4px;
    background-color: ${props => props.theme.colors.primaryColor};
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -2px;
    
    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      left: 30px;
      margin-left: 0;
    }
  }
`;

const TimelineItem = styled.div`
  position: relative;
  width: 50%;
  padding: 0 40px 40px;
  left: ${props => props.position === 'left' ? 0 : '50%'};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    width: 100%;
    padding-left: 70px;
    padding-right: 15px;
    left: 0;
  }
`;

const TimelineDot = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: ${props => props.theme.colors.primaryColor};
  border-radius: 50%;
  top: 10px;
  right: ${props => props.position === 'left' ? '-10px' : 'auto'};
  left: ${props => props.position === 'right' ? '-10px' : 'auto'};
  z-index: 1;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    left: 22px;
    right: auto;
  }
`;

const TimelineContent = styled.div`
  background-color: ${props => props.theme.colors.white};
  padding: 20px;
  border-radius: ${props => props.theme.borders.radius.regular};
  box-shadow: ${props => props.theme.shadows.regular};
`;

const TimelineYear = styled.h3`
  margin-bottom: 10px;
  color: ${props => props.theme.colors.primaryColor};
  font-size: ${props => props.theme.fontSizes.large};
`;

const TimelineText = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  line-height: 1.7;
`;

const Achievements = () => {
  const achievements = [
    {
      year: '2020',
      content: 'Established KALS Academy with the first batch of 20 students',
      position: 'left'
    },
    {
      year: '2021',
      content: 'Expanded curriculum to include specialized courses in structural design',
      position: 'right'
    },
    {
      year: '2022',
      content: 'Started TNPSC exam coaching with 85% success rate in the first batch',
      position: 'left'
    },
    {
      year: '2023',
      content: 'Initiated research projects in collaboration with industry partners',
      position: 'right'
    },
    {
      year: '2024',
      content: 'Recognized as a premier coaching institute for civil engineering examinations',
      position: 'left'
    },
    {
      year: '2025',
      content: 'Expanding our reach with innovative online learning programs',
      position: 'right'
    }
  ];

  return (
    <AchievementSection>
      <div className="container">
        <SectionHeader 
          title="Our Achievements" 
          subtitle="Milestones that mark our journey of excellence" 
        />
        
        <TimelineContainer>
          {achievements.map((achievement, index) => (
            <TimelineItem key={index} position={achievement.position}>
              <TimelineDot position={achievement.position} />
              <TimelineContent>
                <TimelineYear>{achievement.year}</TimelineYear>
                <TimelineText>{achievement.content}</TimelineText>
              </TimelineContent>
            </TimelineItem>
          ))}
        </TimelineContainer>
      </div>
    </AchievementSection>
  );
};

export default Achievements;